/**
 * 매니저 정보 수정 Context
 */

import { ReactNode, createContext, useContext, useState } from "react";

interface ManagerDetailContextType {
  isSuccess: boolean;
  setIsSuccess: (isSuccess: boolean) => void;
}

// 2️⃣ Context 생성
const ManagerDetailContext = createContext<
  ManagerDetailContextType | undefined
>(undefined);

// 3️⃣ Provider Props 타입
interface ManagerDetailProviderProps {
  children: ReactNode;
}

// 4️⃣ Provider 컴포넌트
export const ManagerDetailProvider = ({
  children,
}: ManagerDetailProviderProps) => {
  const [isSuccess, setIsSuccess] = useState(false);

  return (
    <ManagerDetailContext.Provider value={{ isSuccess, setIsSuccess }}>
      {children}
    </ManagerDetailContext.Provider>
  );
};

// 5️⃣ 커스텀 훅
export const useManagerDetailContext = (): ManagerDetailContextType => {
  const context = useContext(ManagerDetailContext);

  if (!context) {
    throw new Error(
      "useManagerDetailContext는 ManagerDetailProvider 내부에서만 사용해야 합니다."
    );
  }

  return context;
};
